(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid-filter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-filter-button]');
    const container = event.target.closest('[data-collection-grid-filter]');
    if (!container) return;

    const buttons = Array.from(container.querySelectorAll('[data-filter-button]'));
    const allButton = container.querySelector('[data-filter-value="__all"]');
    const scrollActiveButtonIntoView = (activeButton) => {
      if (!activeButton) return;
      activeButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };
    const updateItems = () => {
      const activeButton = buttons.find((btn) => btn.getAttribute('aria-pressed') === 'true' && btn.dataset.filterValue !== '__all');
      const activeTag = activeButton ? activeButton.dataset.filterValue : null;

      const items = container.parentElement.querySelectorAll('[data-filter-item]');
      items.forEach((item) => {
        const tag = item.dataset.tag || '';
        const shouldShow = !activeTag || activeTag === tag;
        item.classList.toggle('is-hidden', !shouldShow);
      });

      scrollActiveButtonIntoView(activeButton || allButton);
    };

    if (!button) return;
    const value = button.dataset.filterValue;
    if (value === '__all') {
      buttons.forEach((btn) => btn.setAttribute('aria-pressed', 'false'));
      button.setAttribute('aria-pressed', 'true');
      updateItems();
      return;
    }

    buttons.forEach((btn) => btn.setAttribute('aria-pressed', 'false'));
    button.setAttribute('aria-pressed', 'true');
    if (allButton) allButton.setAttribute('aria-pressed', 'false');
    updateItems();
  });

  document.querySelectorAll('[data-collection-grid-filter]').forEach((container) => {
    const activeButton = container.querySelector('[data-filter-button][aria-pressed="true"]');
    if (activeButton) {
      activeButton.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list-progress"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-collection-list-progress]').forEach((section) => {
    const carousel = section.querySelector('[data-collection-list-progress-carousel]');
    const progressBar = section.querySelector('[data-collection-list-progress-bar]');
    const progressWrapper = section.querySelector('.collection-list-progress__progress');
    const floatingControls = section.querySelectorAll('.collection-list-progress__floating-controls .floating-controls-container__control');
    if (!carousel || !progressBar) return;
    let ticking = false;
    const getCarouselMetrics = () => {
      const total = carousel.cells ? carousel.cells.length : carousel.children.length;
      const visible = Math.max(1, Math.min(total, carousel.groupCells || 1));
      const hasOverflow = carousel.scrollWidth - carousel.clientWidth > 2;
      const shouldShowControls = total > visible && hasOverflow;
      return { total, visible, shouldShowControls };
    };

    const toggleCarouselUi = () => {
      const { shouldShowControls } = getCarouselMetrics();
      if (progressWrapper) {
        progressWrapper.hidden = !shouldShowControls;
      }
      floatingControls.forEach((control) => {
        control.hidden = !shouldShowControls;
      });
      return shouldShowControls;
    };

    const update = () => {
      const { total, visible, shouldShowControls } = getCarouselMetrics();
      const index = carousel.selectedIndex || 0;
      const progress = total > 0 ? Math.min(1, (index + visible) / total) : 0;
      progressBar.valueMax = 100;
      progressBar.valueNow = shouldShowControls ? Math.round(progress * 100) : 100;
      toggleCarouselUi();
      ticking = false;
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    update();
    requestAnimationFrame(update);
    carousel.addEventListener('scroll', onScroll, { passive: true });
    carousel.addEventListener('carousel:change', update);
    window.addEventListener('resize', update);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list-spotlight"] && !Shopify.designMode) return;
  try {
    
  const spotlightSections = document.querySelectorAll("[data-collection-spotlight]");

  spotlightSections.forEach((section) => {
    const items = Array.from(section.querySelectorAll(".collection-list-spotlight__item"));
    const images = Array.from(section.querySelectorAll(".collection-list-spotlight__image"));
    const hoverCapable = window.matchMedia("(hover: hover) and (pointer: fine)");
    const touchCapable = window.matchMedia("(hover: none) and (pointer: coarse)");
    const isTouch = touchCapable.matches || navigator.maxTouchPoints > 0;

    const setActive = (index) => {
      items.forEach((item) => {
        const isActive = item.dataset.index === index;
        item.classList.toggle("is-active", isActive);
        item.classList.remove("is-armed");
        item.setAttribute("aria-current", isActive ? "true" : "false");
      });

      images.forEach((image) => {
        image.classList.toggle("is-active", image.dataset.index === index);
      });
    };

    items.forEach((item) => {
      const titleLink = item.querySelector(".collection-list-spotlight__title-link");
      const buttonLink = item.querySelector(".collection-list-spotlight__button-link a");

      titleLink.addEventListener("click", (event) => {
        if (isTouch) {
          if (!item.classList.contains("is-active")) {
            event.preventDefault();
            setActive(item.dataset.index);
            item.classList.add("is-armed");
            return;
          }

          if (!item.classList.contains("is-armed")) {
            event.preventDefault();
            item.classList.add("is-armed");
          }
        } else if (!item.classList.contains("is-active")) {
          event.preventDefault();
          setActive(item.dataset.index);
        }
      });

      titleLink.addEventListener("focus", () => setActive(item.dataset.index));
      if (buttonLink) {
        buttonLink.addEventListener("focus", () => setActive(item.dataset.index));
      }
    });

    const handleHover = (event) => {
      const item = event.currentTarget;
      setActive(item.dataset.index);
    };

    const handleHoverState = () => {
      items.forEach((item) => {
        if (hoverCapable.matches) {
          item.addEventListener("mouseenter", handleHover);
        } else {
          item.removeEventListener("mouseenter", handleHover);
        }
      });
    };

    handleHoverState();
    if (hoverCapable.addEventListener) {
      hoverCapable.addEventListener("change", handleHoverState);
    } else if (hoverCapable.addListener) {
      hoverCapable.addListener(handleHoverState);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-overlay"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-next-section]');
    if (!button) return;
    const section = button.closest('.shopify-section');
    if (!section) return;
    const nextSection = section.nextElementSibling;
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look-list"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-shop-the-look-list]').forEach((section) => {
    const imageCarousel = section.querySelector('[data-shop-the-look-list-image-carousel]');
    const imageItems = Array.from(section.querySelectorAll('[data-shop-the-look-list-image-item]'));
    const productsCarousel = section.querySelector('[data-shop-the-look-list-products-carousel]');
    const isMobile = window.matchMedia('(max-width: 699px)');

    const clearActiveTooltips = () => {
      section.querySelectorAll('.shop-the-look-list__hotspot-wrap.is-active').forEach((item) => {
        item.classList.remove('is-active');
      });
    };

    const setActiveImage = (index) => {
      imageItems.forEach((item, i) => {
        item.classList.toggle('is-selected', i === index);
        item.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      if (imageCarousel && typeof imageCarousel.select === 'function' && imageCarousel.selectedIndex !== index) {
        imageCarousel.select(index, { instant: true });
      }
    };

    setActiveImage(0);

    section.querySelectorAll('[data-shop-the-look-list-hotspot]').forEach((button) => {
      button.addEventListener('click', () => {
        const blockIndex = parseInt(button.dataset.blockIndex, 10) || 0;
        const productIndex = parseInt(button.dataset.productIndex, 10) || 0;
        setActiveImage(blockIndex);

        if (isMobile.matches) {
          const hotspotWrap = button.closest('.shop-the-look-list__hotspot-wrap');
          const shouldOpen = hotspotWrap && !hotspotWrap.classList.contains('is-active');
          clearActiveTooltips();
          if (shouldOpen && hotspotWrap) {
            hotspotWrap.classList.add('is-active');
          }
          return;
        }

        if (productsCarousel && typeof productsCarousel.select === 'function') {
          productsCarousel.select(productIndex, { instant: false });
        }
      });
    });

    if (imageCarousel) {
      imageCarousel.addEventListener('carousel:change', (event) => {
        const index = event.detail.index || 0;
        setActiveImage(index);
        clearActiveTooltips();
      });
    }

    section.addEventListener('click', (event) => {
      if (event.target.closest('.shop-the-look-list__hotspot-wrap')) return;
      clearActiveTooltips();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
